import { Hidden, Text } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

const Timeline = ({ steps }) => (
  <S.Wrapper>
    {steps.map((step, index) => {
      const { status, description, date, current } = step
      const key = `${index}-${description.replace(' ', '-')}`
      const shouldShowDate = current && date
      const isActive = status !== 'inactive'
      const isDark = status === 'partial'

      return (
        <S.Step key={key} isActive={isActive} isCurrent={current}>
          <S.Bullet status={status} isDark={isDark}>
            {isActive && (
              <Text as="span" noMargin>
                {index + 1}
              </Text>
            )}
          </S.Bullet>
          <Hidden untilKilo kilo>
            {isActive && (
              <S.Description isDark={current}>
                <Text as="span" size="kilo" noMargin>
                  {description}
                </Text>
                {shouldShowDate && (
                  <Text as="span" size="kilo" noMargin>
                    {date}
                  </Text>
                )}
              </S.Description>
            )}
          </Hidden>
        </S.Step>
      )
    })}
  </S.Wrapper>
)

export default Timeline
